import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier } from "../modifiers/index.js";
export const Control = ({ children, className, hasIconsLeft, hasIconsRight, isExpanded, isLoading, ...props }) => {
    const _class = classNames("control", modifier({ hasIconsLeft, hasIconsRight, isExpanded, isLoading }), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
